import SEO from '../../components/SEO';
import BannerMask from '../../components/BannerMask';
import { Container } from 'reactstrap';
import InnerBanner from '../../components/InnerBanner';
import SectionHeader from '../../components/SectionHeader';
import TwoLayoutSection from '../../components/TwoLayoutSection';
import { individualSectionData } from '../../constants/individualsDatas';

const Individuals = () => {
  return (
    <>
      <SEO title="Individuals" />
      <div className="resource">
        <InnerBanner
          title="Individuals"
          description="At Legalligence, we help individuals navigate legal complexities with clarity and confidence. Whether it’s cybercrime, consumer rights, personal disputes, or regulatory issues, our expert-backed, tech-enabled solutions offer fast, reliable support. We simplify the legal process—so you can focus on resolution, not confusion."
        />
        <section className="section-gap-lg">
          <Container>
            <SectionHeader title="For Individuals" />
            <TwoLayoutSection data={individualSectionData} />
          </Container>
        </section>
      </div>
    </>
  );
};

export default Individuals;
